export default __webpack_public_path__ + "static/media/nightscout-dash.cc4d9abe.png";